import api from '../services/api';

export const getTranslations = () => {
    return api.get('/translations').then((res) => res.data.data);
};

export const getConfig = () => {
    return api.get('/configs').then((res) => res.data.data);
};
